import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import API from '../API'
import Header from './Header';
import Knoppie from './Knoppie';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid';
import List from './List';
import Thumb from './Thumb';
import NoImage from '../images/no-image.png';
import useAuth from '../hooks/useAuth';
import { useInjuriesListFetch } from '../hooks/useInjuriesListFetch';

const InjuriesList = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  const { state, loading, error,searchValue, setSearchValue, setIncludeInactive, fetchInjuriesList,setTrigger } = useInjuriesListFetch();
  const observer = useRef();

  console.log(state)

  const lastStockItemRef = useCallback(
    
    
    (node) => {
      console.log("total pages = "+state.total_pages +" and page is " + state.page)
      if (loading || state.ioditems.length >= state.total_results) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchInjuriesList(state.page,searchValue);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, fetchInjuriesList, state.page]
  );

  const handleClick= async (e)=>{

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this injury " + e.target.id +"? This action cannot be overturned!")
      if(confirmation){
        
        console.log(`Sukses, die injury `+e.target.id + ` gaan delete word hier`)
        await API.deleteIODitem(e.target.id,auth.auth.accessToken)
        setTrigger(true)
      
    }else{
      return
    }
    } catch (error) {
        console.log(error)
    }
        
    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

}
  const username = auth.auth.user.username;
  const access = auth.auth.user.userRole;

  return (
    <>
      <Header username={username} role={access} destination={"Payroll"} />


      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue} />
        <div>Injuries on Duty {state.ioditems.length}/{state.total_results}</div>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={true}
            callback={() => setIncludeInactive(true)}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={false}
            callback={() => setIncludeInactive(false)}
          />
          

        </ButtonGrid>
      </div>

      {error && <div>Error loading stock items</div>}

      <List  destination={''}>
       
        {state.ioditems.length > 0 ? (
          state.ioditems.map((item, index) => (
            <div className='SingleEmployee' key={item._id} ref={index === state.ioditems.length - 1 ? lastStockItemRef : null}>
              

              <Thumb
              clickable={true}
              name={item.employee.givname + " " +item.employee.surname}
              area={item.accidentdate}
              image={item.imageUrl ? item.imageUrl : NoImage}
              root={'ioditem'}
              from={'InjuriesList'}
              id={item._id}
              employeeid={item._id}>
                
              <div>{item.accidentdescription}</div>  

              {access === "administrator" && (
                <Knoppie 
                text={"Delete"} 
                clickable={true}
                employeeid={item._id} 
                callback={handleClick} />
              )}
              </Thumb>
              
         
            </div>
          ))
        ) : (
          <div>No Injury on Duties found.</div>
        )}
      </List>

      {loading && <h1>Loading more items...</h1>}
    </>
  );
};

export default InjuriesList;
